import { useState } from 'react'

import { AdminSliderPanel } from '@/components/AdminSliderPanel'
import { AdminButton } from '@/components/shared/AdminButton'
import { useCancelLoad } from '@/hooks/useCancelLoad'

import type { LoadPanelProps } from './types'

export const CancelLoadSlider = ({ load, onChange }: LoadPanelProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const cancelLoad = useCancelLoad()

  const handleConfirm = () => {
    cancelLoad.mutate(
      { loadId: load._id },
      {
        onSuccess: () => {
          setIsOpen(false)
          onChange?.()
        },
      },
    )
  }

  return (
    <>
      <AdminButton
        className="btn-sm btn-warning"
        icon="ban"
        onClick={() => setIsOpen(true)}
      >
        Cancel this load
      </AdminButton>
      <AdminSliderPanel
        title="Cancel load"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div className="flex flex-col gap-4">
          <p>
            Are you sure you want to cancel this load for{' '}
            <strong>{load.createdBy?.company}</strong>?
          </p>
          <p className="text-sm opacity-70">
            This will attempt to cancel the pickup with the carrier and notify
            any spot quote carriers. The load can be uncanceled afterwards, but
            carrier cancellations may not be reversible.
          </p>
          <div className="flex justify-end gap-2">
            <AdminButton
              className="btn-sm btn-ghost"
              onClick={() => setIsOpen(false)}
              disabled={cancelLoad.isPending}
            >
              Never mind
            </AdminButton>
            <AdminButton
              className="btn-sm btn-error"
              icon="ban"
              loading={cancelLoad.isPending}
              onClick={handleConfirm}
            >
              Yes, cancel this load
            </AdminButton>
          </div>
        </div>
      </AdminSliderPanel>
    </>
  )
}
